import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
# TextCounter Component
**/
const TextCounter = (props) => {
  const { label, digit } = props;
  return (
    <span {...resolveTestId(props)} {...resolve(props, 'text')}>
      <span {...resolve(props, 'digit')}>{digit}</span>
      <span {...resolve(props, 'label')}>{label}</span>
    </span>
  );
};

TextCounter.displayName = 'TextCounter';
TextCounter.propTypes = {
  /** Label text for the counter. */
  label: PropTypes.string,
  /** The actual value to display in the counter. */
  digit: PropTypes.number.isRequired,
  /** Available Style Keys. */
  style: PropTypes.shape({
    /** Top level style applied to the container. */
    text: PropTypes.object,
    /** Style applied to the digit part of the counter. */
    digit: PropTypes.object,
    /** Style applied to the label part of the counter. */
    label: PropTypes.object
  })
};

export default TextCounter;



// WEBPACK FOOTER //
// ./~/nucleus-core/counters/TextCounter.js